<template>
    <v-card id="print-target" >
        <v-card-title class="justify-center pa-3 pt-6 pa-md-7 pt-md-14">
            <h3 class="report-title">전자제조지원단 기술자문 보고서</h3>
        </v-card-title>
        <v-card-text>
            <v-sheet class="mb-8 mb-md-15">
                <div class="counsel-report">
                    <table class="table--primary">
                        <tr>
                            <th rowspan="2">작성업체</th>
                            <td rowspan="2">{{request.requester.companyName}}</td>
                            <th>담당자명</th>
                            <td>{{request.requester.workerName}}</td>
                        </tr>
                        <tr>
                            <th>연락처</th>
                            <td>{{request.requester.phone.phoneNumberFormat()}}</td>
                        </tr>
                        <tr v-if="isLong">
                            <th rowspan="2">분야</th>
                            <td rowspan="2">{{areaName}}</td>
                            <th>자문요청일</th>
                            <td>{{request.startsAt.toDate()}}</td>
                        </tr>
                        <tr v-else>
                            <th rowspan="2">분야</th>
                            <td rowspan="2">{{areaName}}</td>
                            <th>자문요청일</th>
                            <td>{{request.createdAt.toDate()}}</td>
                        </tr>
                        <tr v-if="isLong">
                            <th>자문종료일</th>
                            <td>{{request.endsAt.toDate()}}</td>
                        </tr>
                        <tr v-else>
                            <th>자문종료일</th>
                            <td>{{request.endedAt.toDate()}}</td>
                        </tr>
                        <counsels-report-row colspan="3" label="자문주제" :content="request.title" />
                        <counsels-report-row colspan="3" label="기술자문내용" :content="request.content" />
                        <counsels-report-row colspan="3" label="첨부파일">
                            <div class="text-btn-wrap">
                                <v-btn v-for="file in request.files" :key="file._id" :href="file.url" download text color="primary" class="text-decoration-underline">
                                    {{ file.fileName }}
                                </v-btn>
                            </div>
                        </counsels-report-row>
                    </table>
                </div>
            </v-sheet>

            <v-sheet class="mb-9 mb-md-16">
                <div class="mb-4">
                    <h4 class="report-title2">답변내용</h4>
                </div>
                <div class="row--primary">
                    <v-row no-gutters v-for="response in request.responses" :key="response._id" align="center">
                        <v-col cols="12" md="3">
                            <div class="report-nickname"><v-avatar size="22">A</v-avatar>{{ response.responder.nickname }}</div>
                        </v-col>
                        <v-col cols="12" md="7">
                            {{ response.content }}
                            <div class="mt-1 mt-md-2">
                                <div class="text-btn-wrap">
                                    <v-btn v-for="file in response.files" :key="file._id" :href="file.url" download text color="primary" class="text-decoration-underline">
                                        {{ file.fileName }}
                                    </v-btn>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12" md="2" class="text-right text-md-center">{{ response.createdAt.toDateTime() }}</v-col>
                    </v-row>
                </div>
            </v-sheet>

            <v-sheet>
                <div class="report-bottom">
                    <div class="report-bottom__txt">위의 자문 결과에 대한 사실을 확인합니다.</div>
                    <div class="report-bottom__date">{{ now }}</div>
                    <div class="report-bottom__company">
                        <p>{{ request.requester.companyName }} {{ request.requester.ceoName }}</p>
                        <p>KEA전자제조지원단</p>
                    </div>
                    <div class="report-bottom__tit">한국 전자정보 통신 산업 진흥회 귀하</div>
                </div>
            </v-sheet>
        </v-card-text>
    </v-card>
</template>

<script>
import { COUNSEL_REQUEST_TYPES } from "@/pages/console/counsels/CounselListPage.vue";
import CounselsReportRow from "./counsels-report-row.vue";
import dayjs from "dayjs";
export default {
    components: { CounselsReportRow },
    props: ["request"],
    computed: {
        areaName() {
            return `${this.request.area.parent.name} > ${this.request.area.name}`;
        },
        isLong() {
            return this.request.type == COUNSEL_REQUEST_TYPES.long;
        },
        now() {
            return dayjs().format("YYYY년 MM월 DD일");
        },
    },
};
</script>

<style lang="scss" scoped>
@import url(//spoqa.github.io/spoqa-han-sans/css/SpoqaHanSansNeo.css);
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";
.v-application *{
    letter-spacing: -.01em !important;
    font-family: 'Spoqa Han Sans Neo', Roboto, sans-serif;
}
@media (max-width:768px){
    .v-dialog>.v-card>.v-card__subtitle, .v-dialog>.v-card>.v-card__text{
        padding:0 12px 12px;
    }
}

.report-title{
    font-size: 40px;
    color:#222;
}
.report-title2{
    font-size: 28px;
    color:#222;
}
@media (max-width:768px){
    .report-title{
        font-size: 20px;
    }
    .report-title2{
        font-size: 18px;
    }
}

.table--primary{
    width:100%;
    border-spacing: 0;
    border-top:1px solid $color-primary;
    th, td{
        font-size: 16px;
        border-bottom:1px solid #e6e6e6;
        padding: 15px 20px;
    }
    th{
        font-weight:500;
        color:#222;
        background-color: #f7fcfe;
    }
    td{
        color: #7e7e7e;
    }
}
@media (max-width:768px){
    .table--primary{
        tr{
            th, td{
                font-size: 14px;
                padding:10px 15px;
            }
        }
    }
    .table--primary, .table--primary tr, .table--primary th, .table--primary td{
        display: block;
    }
}

.text-btn-wrap{
    margin:-4px;
    .v-btn:not(.v-btn--round).v-size--default{
        height: auto;
        min-width: auto;
        font-weight:400;
        padding:2px;
        margin:4px;
    }
}

.row--primary{
    border-top:1px solid #222;
    .row{
        color:#7e7e7e;
        padding:15px 25px;
        border-bottom:1px solid #e6e6e6;
    }
}
@media (max-width:768px){
    .row--primary{
        .row{
            padding: 15px 5px;
            margin:-5px 0;
            [class*="col"]{
                padding:5px 0;
            }
        }
    }
}

.report-nickname{
    display:flex;
    align-items:center;
    font-weight:500;
    color:#222;
    .v-avatar{
        font-size: 14px;
        font-weight: 600;
        color:$color-primary;
        border:1px solid $color-primary;
        margin-right: 8px;
    }
}

.report-bottom{
    font-size: 18px;
    text-align: center;
    color: #222;
    &__txt{
        margin-bottom: 20px;
    }
    &__date{
        font-size: 16px;
        color:#7e7e7e;
        margin-bottom: 25px;
    }
    &__company{
        max-width: 300px;
        font-size: 16px;
        border-top: 1px solid #e6e6e6;
        border-bottom: 1px solid #e6e6e6;
        padding: 15px 0;
        margin: 0 auto 50px;
        p{
            margin-bottom: 5px;
            &:last-child{
                margin-bottom: 0;
            }
        }
    }
    &__tit{
        font-size: 28px;
        font-weight: 600;
        margin-bottom: 60px;
    }
}
@media (max-width:768px){
    .report-bottom{
        font-size: 16px;
        &__txt{
            margin-bottom: 15px;
        }
        &__date{
            font-size: 14px;
            margin-bottom: 15px;
        }
        &__company{
            font-size: 14px;
            padding: 10px 0;
            margin: 0 auto 30px;
            p{
                margin-bottom: 2px;
            }
        }
        &__tit{
            font-size: 20px;
            margin-bottom: 30px;
        }
    }
}
</style>
